import React, { useState } from 'react';
import styles from './FAQ.module.scss';
import right_caret from '../../../assets/images/right_caret.png'
import down_caret from '../../../assets/images/down_caret.png'

const Item = ({ display, header, content }) => {
  const [isActive, setIsActive] = useState(false);
  
  if(display) {
    return (
      <div>
        <div className={styles["item"]}>
            <div className={styles[isActive ? 'item-header-bold' : 'item-header-regular']} onClick={() => setIsActive(!isActive)}>
              <div className={styles["header-title"]}>{header}</div>
              <div className={styles["header-collapse"]}>
                <img src={isActive ? down_caret : right_caret} alt='caret toggle for faq section'></img>
              </div>
            </div>
        </div>
        <div>
          {isActive && <div className={styles["item-content"]}>{content}</div>}
        </div>
      </div>
    );
  }
  else {
    return null;
  }
};

export default Item;